import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type BoardStatsProps = ComponentPropsWithoutRef<'div'>;

export const BoardStats = memo(({ className, ...restOfProps }: BoardStatsProps) => {
  return (
    <div
      className={cn('flex items-center gap-1 font-medium ads:text-secondary text-12 text-gray-11', className)}
      {...restOfProps}
    />
  );
});

BoardStats.displayName = 'BoardStats';
